import { render, staticRenderFns } from "./OrderTopBar.vue?vue&type=template&id=514183f5"
import script from "./OrderTopBar.vue?vue&type=script&lang=js"
export * from "./OrderTopBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports